__turbopack_context__.v({
  "button": "Button-module__8cr-Ka__button",
  "button__svg": "Button-module__8cr-Ka__button__svg",
  "button__text": "Button-module__8cr-Ka__button__text",
  "svg": "Button-module__8cr-Ka__svg",
});
